import Swiper from "swiper";
import {Navigation} from "swiper/modules";

export function initNewsSlider(wrapper = document) {
    const sliderContainers = wrapper.querySelectorAll(".js-news-slider, .js-videos-slider");

    if (sliderContainers.length > 0) {
        const containerLargeWidth = 1160;

        const calcOffset = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth > containerLargeWidth) {
                return (windowWidth - (containerLargeWidth - 40)) / 2;
            } else if (windowWidth >= 768) {
                return 20;
            }
            return 20; // Mobile offset
        };

        sliderContainers.forEach(slider => {
            const swiper = new Swiper(slider, {
                modules: [Navigation],
                speed: 400,
                slidesPerView: "auto",
                spaceBetween: 20,
                centeredSlides: false,
                watchSlidesProgress: true,
                slidesOffsetBefore: calcOffset(),
                slidesOffsetAfter: calcOffset(),
                navigation: {
                    nextEl: slider.parentElement.querySelector('.swiper-button-next'),
                    prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    0: {
                        spaceBetween: 20,
                    },
                    768: {
                        spaceBetween: 40,
                    }
                }
            });

            const resizeObserver = new ResizeObserver(() => {
                const newOffset = calcOffset();
                swiper.params.slidesOffsetBefore = newOffset;
                swiper.params.slidesOffsetAfter = newOffset;
                swiper.update();
            });

            resizeObserver.observe(document.body);
        });
    }
}
